// extracted by mini-css-extract-plugin
module.exports = {"darkThemeLogo":"DagsterPlusLogo_darkThemeLogo__WikZ3","lightThemeLogo":"DagsterPlusLogo_lightThemeLogo__MmEO_"};